module.exports = __webpack_public_path__ + "img/editor.fdfef270.svg";